var map = {
	"./10sec_backward.svg": 188,
	"./10sec_forward.svg": 189,
	"./add-image-icon.svg": 374,
	"./alert-white.svg": 190,
	"./alert.svg": 55,
	"./arrow-down-icon.svg": 72,
	"./arrow-down.svg": 84,
	"./arrow-right-icon.svg": 375,
	"./arrow.svg": 376,
	"./attention.svg": 106,
	"./attentiondark.svg": 185,
	"./avatar-profile.svg": 177,
	"./avatar.svg": 175,
	"./bg.svg": 377,
	"./block-icon.svg": 191,
	"./bronze-cup-icon.svg": 378,
	"./calendar.svg": 379,
	"./camera-icon.svg": 380,
	"./camera.svg": 192,
	"./caution.svg": 127,
	"./chat.svg": 381,
	"./checked-step.svg": 152,
	"./checked.svg": 187,
	"./close-icon.svg": 178,
	"./close.svg": 193,
	"./cloud-icon.svg": 382,
	"./colapse-icon.svg": 194,
	"./collapse.svg": 383,
	"./concurrent.svg": 195,
	"./config-icon-white.svg": 196,
	"./config-icon.svg": 125,
	"./copy.svg": 384,
	"./correct.svg": 197,
	"./correct2.svg": 128,
	"./delete-white.svg": 180,
	"./delete.svg": 385,
	"./edit.svg": 386,
	"./export-icon.svg": 387,
	"./eye-color.svg": 388,
	"./eye-hide-color.svg": 389,
	"./eye.svg": 390,
	"./face-white.svg": 181,
	"./febracis.svg": 391,
	"./file-csv.svg": 198,
	"./file-doc-2.svg": 199,
	"./file-jpg.svg": 200,
	"./file-pdf.svg": 201,
	"./file-png.svg": 202,
	"./file-ppt.svg": 203,
	"./file-xls.svg": 204,
	"./file-zip.svg": 205,
	"./game-ranking.svg": 206,
	"./golden-cup-icon.svg": 392,
	"./group-icon.svg": 393,
	"./group.svg": 394,
	"./home-icon.svg": 124,
	"./icon-download.svg": 207,
	"./information-icon.svg": 395,
	"./instagram-white.svg": 183,
	"./kopa-logo.svg": 28,
	"./lang-ico.svg": 186,
	"./loading-white.svg": 129,
	"./loading.svg": 396,
	"./logo-kopa.svg": 123,
	"./logout.svg": 397,
	"./networkFailed.svg": 208,
	"./no-content.svg": 398,
	"./no-video.svg": 70,
	"./notification-icon.svg": 399,
	"./options.svg": 400,
	"./paper-icon.svg": 401,
	"./pause_overlay.svg": 209,
	"./phone.svg": 176,
	"./photo-camera.svg": 179,
	"./pin.svg": 402,
	"./pinned.svg": 210,
	"./pitch-icon.svg": 403,
	"./play.svg": 130,
	"./play_overlay.svg": 211,
	"./plus-detail-icon.svg": 404,
	"./plus-icon.svg": 405,
	"./plus.svg": 406,
	"./podium-icon.svg": 131,
	"./producer-cam-icon.svg": 95,
	"./producer-cam-mute-icon.svg": 96,
	"./producer-down-icon.svg": 407,
	"./producer-mic-icon.svg": 97,
	"./producer-mic-mute-icon.svg": 98,
	"./producer-signal-icon.svg": 408,
	"./producer-up-icon.svg": 409,
	"./qr-code-icon.svg": 410,
	"./question-2.svg": 411,
	"./quizzes-icon.svg": 412,
	"./search-icon.svg": 413,
	"./selected.svg": 414,
	"./send.svg": 415,
	"./sign-out-icon.svg": 126,
	"./silver-cup-icon.svg": 416,
	"./speedometer.svg": 417,
	"./start-transmission-icon.svg": 132,
	"./streaming.svg": 418,
	"./survey-icon.svg": 419,
	"./twitter-white.svg": 182,
	"./upload-multiple.svg": 420,
	"./upload.svg": 421,
	"./user-icon.svg": 422,
	"./video-2-icon.svg": 423,
	"./video-icon.svg": 424
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 373;